// constants.js
// Enum values (brands, categories, proteins, textures, etc.) are now served
// from the backend via GET /api/enums and accessed through the useEnums() hook.
// Only non-enum UI constants remain here.

export const CONSTANTS = {
    // Helper function to convert array to object for multi-select
    convertArrayToObject: (array) => {
      return array.reduce((obj, item) => {
        obj[item] = item;
        return obj;
      }, {});
    },

    // Boolean options (pure UI labels, not database enums)
    BOOLEAN_OPTIONS: {
      GRAIN_FREE: {
        TRUE: "Grain-Free",
        FALSE: "With grains"
      },
      GMO_FREE: {
        TRUE: "No GMO only"
      },
      RAW_FOOD: {
        TRUE: "Contains Raw Food",
        FALSE: "Does not contain Raw Food"
      },
      PRESCRIPTION: {
        TRUE: "Prescription Required",
        FALSE: "No Prescription Required"
      },
      LID: {
        TRUE: "Limited Ingredient Diet only"
      },
      GUARANTEED_ANALYSIS: {
        TRUE: "Include Guaranteed Analysis"
      },
      NOVELTY_PROTEINS: {
        TRUE: "Contains Novel Protein",
        NOVEL_ONLY: "Novel-only"
      },
      SINGLE_PROTEIN: {
        TRUE: "Single Protein"
      },
      HYDROLYZED_PROTEIN: {
        TRUE: "Hydrolyzed Protein only"
      }
    }
  };

  export default CONSTANTS;
